import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderService } from '../services/order.service';
import { OrderModel } from '../models/OrderModel';
import { OrderItemsModel } from '../models/OrderItemsModel';
import { EventEmitterService } from '../event-emitter.service';
import { ProperityService } from '../services/properity.service';
import { Globals } from "../globals";
import { ConfigClass } from '../config';

@Component({
    selector: 'app-orders-add-modal',
    templateUrl: './orders-add-modal.component.html',
    styleUrls: ['./orders-add-modal.component.css']
})
export class OrdersAddModalComponent implements OnInit {

    orderDetails: OrderModel = {};
    orderItems: OrderItemsModel[] = [];
    status = '';
    techname = "";
    sendNotification: boolean = false;
    message: string = "";
    newTargetDate: string = "";
    rollbackDescription: string = "";
    isAgent: boolean = false;
    newPaidStatus: boolean = false;
    notPaidJustification: string = "";
    technicianFeedback: string = "";

    constructor(public dialogRef: MatDialogRef<OrdersAddModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, private orderService: OrderService, private eventEmitterService: EventEmitterService,
        public globals: Globals, private properityService: ProperityService) { }

    ngOnInit(): void {
        this.orderDetails = this.data.orderDetails[0];
        this.isAgent = this.data.isAgent;
        this.technicianFeedback = this.orderDetails.technicianFeedback;
        if (this.data) {
            this.status = this.data.status;
            this.newTargetDate = this.globals.formateDate(this.orderDetails.targetDate);
            // if (this.data.status === 'PENDING' || this.data.status === "CS_ASSIGNING_CONFIRMATION") {
            if (ConfigClass.getPaymentStatus) {
                this.orderService.GetOrderItems(this.data.orderId).subscribe(items => {
                    this.orderItems = items['content'];
                })
            }
            // }
            // if (this.data.status === 'ASSIGNED') {
            this.newPaidStatus = this.orderDetails.paid;
            this.notPaidJustification = this.orderDetails.notPaidJustification;
            // }
            // else if (this.data.status === 'DONE') {
            if (this.orderDetails.rate) {
                this.orderDetails.rate = this.orderDetails.rate.length == 2 ? this.orderDetails.rate[1] + " Stars" : this.orderDetails.rate;
            }
            // }
        }
    }

    gotoAssighOrder(technicianName) {
        const dataObj = {
            'orderId': this.data.orderId,
            'technicianName': technicianName,
        };
        this.orderService.AssignteOrder(dataObj).subscribe(a => {
            this.globals.presentSuccessToast("Order has been assigned successfully");
            this.dialogRef.close(true);
        });
    }

    gotoVerifyOrder() {
        const dataObj = {
            'orderId': this.data.orderId,
            'technicianFeedback': this.technicianFeedback,
            'totalPrice': this.orderDetails.totalPrice,
            "notPaidJustification": this.newPaidStatus ? "" : this.notPaidJustification,
            "paid": this.newPaidStatus
        };
        this.orderService.CompleteOrder(dataObj).subscribe(a => {
            this.globals.presentSuccessToast("Order has been completed successfully");
            this.dialogRef.close(true);
        });
    }

    gotoRollBackOrder() {
        const dataObj = {
            'orderId': this.data.orderId,
            'rollbackDescription': this.rollbackDescription,
            'targetDate': this.orderDetails.targetDate,
            'technician': this.orderDetails.technician,
        };
        this.orderService.RollBackOrder(dataObj).subscribe(a => {
            this.globals.presentSuccessToast("Order has been rollbacked successfully");
            this.dialogRef.close(true);
        });
    }

    onClickCancel(): void {
        this.dialogRef.close();
    }

    confirmAssignOrder() {
        var data = {
            "orderId": this.orderDetails.orderId
        }
        this.orderService.confirmAssignOrder(data).subscribe(a => {
            this.dialogRef.close(true);
            this.globals.presentSuccessToast("Order has been confirmed successfully");
        });
    }

    confirmCompleteOrder() {
        var data = {
            "orderId": this.orderDetails.orderId,
            "paid": this.newPaidStatus,
            "notPaidJustification": this.newPaidStatus ? "" : this.notPaidJustification
        }
        this.orderService.confirmCompleteOrder(data).subscribe(a => {
            this.dialogRef.close(true);
            this.globals.presentSuccessToast("Order has been confirmed successfully");
        });
    }

    updateTechName() {
        var data = {
            "orderId": this.orderDetails.orderId,
            "technician": this.techname
        }
        this.orderService.updateOrderTechName(data).subscribe(result => {
            this.globals.presentSuccessToast("Order has been updated successfully");
            this.orderDetails.technician = this.techname;
            this.techname = "";
        });
    }

    updatePaidStatus() {
        var data = {
            "orderId": this.orderDetails.orderId,
            "paid": this.newPaidStatus,
            "notPaidJustification": this.newPaidStatus ? "" : this.notPaidJustification
        }
        this.orderService.updateOrderTechName(data).subscribe(result => {
            this.globals.presentSuccessToast("Order has been updated successfully");
            this.orderDetails.paid = this.newPaidStatus;
            this.dialogRef.close(true);
        });
    }

    updateTargetDate() {
        var data = {
            "orderId": this.orderDetails.orderId,
            "targetDate": this.globals.formateDate(this.newTargetDate),
            "status": "PENDING"
        }
        this.orderService.updateOrderTechName(data).subscribe(result => {
            this.dialogRef.close(true);
            this.globals.presentSuccessToast("Order has been updated successfully");
        });
    }

    cancelOrder() {
        this.orderService.cancelOrder(this.orderDetails.orderId).subscribe(result => {
            this.dialogRef.close(true);
            this.globals.presentSuccessToast("Order has been cancelled successfully");
        });
    }
}
